export class  TrackedWorkout {
    id: string = null;
    createdBy: string = null;
    creationDate: string = null;
    /** When the user actually started the live session timer (ISO). Absent = planned / not started. */
    startD?: string = null;
    /** When the workout was completed (ISO). Prefer over trackingCompleted for duration end. */
    endD?: string = null;
    lastModifiedBy: string = null;
    lastModifiedDate: string = null;
    sets: any[] = [];
    trackingCompleted: string = null;
    workout: string = null;
    workoutProgram: string = null;
    /** "program" (exercise-based) or "split" (muscle-group targets). */
    workoutProgramKind?: "program" | "split";
    workoutProgramTitle: string = null;
    workoutTitle: string = null;
    /** Split targets copied from the program on import. */
    splitTargets?: Array<{ muscle: string; sets: number; role?: "primary" | "secondary" }>;
    referenceId?: string = null;
    date?: string;

    constructor (init: Partial<TrackedWorkout>){
        Object.assign(this, init);
    }
}